import script from "./Gartenkultur-Contacts.vue?vue&type=script&setup=true&lang=js"
export * from "./Gartenkultur-Contacts.vue?vue&type=script&setup=true&lang=js"

import "./Gartenkultur-Contacts.vue?vue&type=style&index=0&id=09bd5300&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09bd5300"]])

export default __exports__